import { render, staticRenderFns } from "./newHeader.vue?vue&type=template&id=07c6644c"
import script from "./newHeader.vue?vue&type=script&lang=js"
export * from "./newHeader.vue?vue&type=script&lang=js"
import style0 from "./newHeader.vue?vue&type=style&index=0&id=07c6644c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports